module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("user_profile", [["div",{"class":"title-block no-bdr simple"},[["div",{"class":"page-width"},[["div",{"class":"title"},[["p",{},[["textNode",{"text":"Member profile"}]]]]]]]]],["div",{"class":"page-width user-profile-table"},[["table",{},[["tr",{},[["td",{},[["strong",{},[["textNode",{"text":"Username"}]]]]],["td",{},[["span",{},[],[["login","__text",true]]]]]]],["tr",{},[["td",{},[["strong",{},[["textNode",{"text":"Email"}]]]]],["td",{},[["span",{},[],[["email","__text",true]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/user/profile.tpl
// module id = 1122
// module chunks = 4